module.exports = __webpack_public_path__ + "img/deleteicon.6ac8d682.svg";